import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BinarySelectGroup } from "../../../binary-select/binary-select-group/BinarySelectGroup";
export const RadioGroup = forwardRef((props, ref) => {
    const { selection, layout = "column" } = props;
    const isSelected = (key) => selection === key;
    return (_jsx(BinarySelectGroup, { ref: ref, "data-testid": "RadioGroup", getNewSelection: (key) => key, isSelected: isSelected, layout: layout, ...props }));
});
RadioGroup.displayName = "RadioGroup";
